import React from "react";
// import "./PrivacyPolicy.css"; // Ajouter un fichier CSS si nécessaire
import SEO from "../SEO/SEO";

const PrivacyPolicy = () => {
  return (
    <div>
      <SEO
        title="Privacy Policy - RS Transports"
        description="Privacy Policy of RS Transports. Learn how we handle your personal data, cookies, and privacy rights."
        keywords="RS Transports, privacy policy, data protection, cookies, GDPR compliance"
      />

      <section id="privacy-policy" className="py-5">
        <div className="container">
          <h1 className="text-center mb-4">Privacy Policy</h1>

          <div className="row">
            <div className="col-md-12">
              <div className="card h-100">
                <div className="card-body">
                  <h2 className="card-title">1. Introduction</h2>
                  <p>
                    RS Transports is committed to protecting your privacy. This Privacy Policy explains how we collect, use, and safeguard your personal data when you use our website.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-md-12 mt-4">
              <div className="card h-100">
                <div className="card-body">
                  <h2 className="card-title">2. Data Collection</h2>
                  <p>We only collect personal data necessary for processing your bookings and payments. We do not store credit card information.</p>
                </div>
              </div>
            </div>

            <div className="col-md-12 mt-4">
              <div className="card h-100">
                <div className="card-body">
                  <h2 className="card-title">3. Use of Cookies</h2>
                  <p>We use cookies to enhance user experience and analyze website traffic. You can manage cookie settings in your browser.</p>
                </div>
              </div>
            </div>

            <div className="col-md-12 mt-4">
              <div className="card h-100">
                <div className="card-body">
                  <h2 className="card-title">4. Your Rights</h2>
                  <p>You have the right to request access, correction, or deletion of your personal data. To exercise these rights, contact us at <a href="mailto:contact@rstransports.com">contact@rstransports.com</a>.</p>
                </div>
              </div>
            </div>

            <div className="col-md-12 mt-4">
              <div className="card h-100">
                <div className="card-body">
                  <h2 className="card-title">5. Contact</h2>
                  <p>If you have any questions regarding this Privacy Policy, please contact us at:</p>
                  <p>Email: <a href="mailto:contact@rstransports.com">contact@rstransports.com</a></p>
                  <p>Phone: +33 6 68 16 08 42</p>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>
    </div>
  );
};

export default PrivacyPolicy;
